export const firebaseConfig = {
  apiKey: "AIzaSyARWJ76h61HHoJLDSobzNeKsrUAJVivPzE",
  authDomain: "fear-d1be0.firebaseapp.com",
  databaseURL: "https://fear-d1be0.firebaseio.com",
  projectId: "fear-d1be0",
  storageBucket: "fear-d1be0.appspot.com",
  messagingSenderId: "740155803494"
};



// WEBPACK FOOTER //
// ./src/config.ts